module.exports = __webpack_public_path__ + "img/10x10SCM-min.41118f53.png";